// Rxjs
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Angular Modules
import {APP_INITIALIZER, NgModule, Optional, SkipSelf, Injector, ErrorHandler} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

// Services
import { init as coreInitializer } from './core.initializer';

// Modules
import { InterceptorsModule } from './core.interceptors';
import { init as ultimaInitializer } from "./ultima.initializer";
import { NgxsModule } from '@ngxs/store';
import {ToastrModule} from "ngx-toastr";
import {AppErrorHandler} from '@app/app.errors';

// Translation
export class CoreTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): any {
    return this.http.get(`assets/i18n/${lang}.json`)
      .pipe(
        catchError(() => of({}))
      );
  }
}

export function httpLoaderFactory(http: HttpClient) {
  return new CoreTranslationLoader(http);
}

// App init
const INITIALIZERS = [
  coreInitializer,
  ultimaInitializer
];

export function initializersFactory(injector: Injector) {
  return async () => {
    for (let i = 0; i < INITIALIZERS.length; i++) {
      await INITIALIZERS[i](injector);
    }
  }
}

const PROVIDERS = [
  // Init application
  {provide: APP_INITIALIZER, multi: true, useFactory: initializersFactory, deps: [Injector]},

  // AppErrorHandler
  {provide: ErrorHandler, useClass: AppErrorHandler}
];

const MODULES = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  CommonModule,
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
  InterceptorsModule,
  ToastrModule.forRoot(),
  NgxsModule.forRoot([])
];


@NgModule({
  providers: PROVIDERS,
  imports: MODULES
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`CoreModule has already been loaded. Import Core modules in the AppModule only.`);
    }
  }
}
